import React, { useContext } from 'react';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { InputContext } from '../chat-input';

const InputSend = () => {
    const inputHook = useContext(InputContext);
    const { isDisabled, isSending, pendingFilesCount, lengthError, onSend } = inputHook!;

    return (
        <Tooltip title={pendingFilesCount > 0 ? 'در حال بارگذاری فایل' : 'ارسال'} arrow>
            <span>
                <IconButton
                    disabled={!!lengthError || isDisabled || pendingFilesCount > 0}
                    onClick={onSend}
                    sx={{
                        width: 40,
                        height: 40,
                        bgcolor: 'primary.main',
                        color: 'primary.contrastText',
                        '&:hover': { bgcolor: 'primary.dark' },
                        '&.Mui-disabled': { bgcolor: 'action.disabledBackground', color: 'text.disabled' },
                    }}>
                    {isSending ? (
                        <CircularProgress size={16} thickness={5} color="inherit" />
                    ) : (
                        <i className="fa-light fa-paper-plane-top" style={{ fontSize: 16 }} />
                    )}
                </IconButton>
            </span>
        </Tooltip>
    );
};

export default InputSend;
